export default __webpack_public_path__ + "static/media/Ballroll_00045.fdeaf7d7.png";